import React from "react";
import { ShieldCheck } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CertificeringenVertrouwen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const partners = [{
    name: "Zapier",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/partner_zapier.png"
  }, {
    name: "OpenAI",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/partner_openai.png"
  }, {
    name: "Meta",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/partner_meta.png"
  }, {
    name: "Google",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631459/img/partner_google.png"
  }];
  return <section data-section-id="16649" id="onze-technologieën" ref={ref} className={`w-full border-y border-border/20 bg-background/95 backdrop-blur-xl py-3 transition-all duration-700 dark bg-background text-foreground ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8">
        <div className="flex flex-wrap justify-center md:justify-start items-center gap-x-4 gap-y-2 text-xs font-mono text-muted-foreground/70">
          <div className="flex items-center gap-2 text-accent-foreground/90">
            <ShieldCheck className="h-4 w-4" />
            <span className="font-semibold tracking-tight text-foreground/90 font-default">
              Tech Stack
            </span>
          </div>
          
          <Separator orientation="vertical" className="h-3 bg-border/30 hidden sm:block" />
          
          <span className="whitespace-nowrap">
            ENGINE <span className="text-foreground/60">AI-DRIVEN</span>
          </span>
          
          <Separator orientation="vertical" className="h-3 bg-border/30 hidden sm:block" />
          
          <span className="whitespace-nowrap">
            FOCUS <span className="text-foreground/60">DATA-CONNECTED</span>
          </span>
        </div>

        <div className="flex items-center gap-6 sm:gap-8 opacity-100">
          {partners.map((partner, i) => <div key={partner.name} data-index={i} className="group relative flex items-center justify-center">
              <img src={partner.logo} alt={`${partner.name} Technology Partner`} className="h-5 w-auto object-contain grayscale opacity-40 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110" />
            </div>)}
        </div>
      </div>
    </section>;
}